import {
  createRamboCasingFrames,
  createRamboFrames,
  createRamboStreakFrames,
  RAMBO_CASING_COUNT,
  RAMBO_DURATION,
  RAMBO_SHOT_COUNT,
} from "../../core/rambo-keyframes.js";

export const meta = Object.freeze({
  id: "rambo",
  label: "Rambo Orbi",
  duration: RAMBO_DURATION,
  description: "Comic-Action mit Stirnband, zwei stilisierten Maschinengewehren, Schnellfeuer und fallenden Hülsen.",
  tags: ["body", "expression", "action", "comic", "rapid-fire", "one-shot", "loopable"],
});

export async function run({ elements, scene, animate }) {
  const requiredElements = [
    elements.ramboHeadband,
    elements.ramboGunLeft,
    elements.ramboGunRight,
    elements.ramboFlashLeft,
    elements.ramboFlashRight,
  ];
  if (requiredElements.some((element) => !element)) {
    throw new Error("Die Rambo-Sequenz benötigt Stirnband, beide Comic-Waffen und beide Mündungsblitze.");
  }
  if (scene?.ramboCasings?.length !== RAMBO_CASING_COUNT || scene?.ramboStreaks?.length !== RAMBO_SHOT_COUNT) {
    throw new Error("Die Rambo-Sequenz benötigt den vollständigen Hülsen- und Schussstreifen-Layer.");
  }

  const frames = createRamboFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.actor, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.brows, frames.brows, options),
    animate(elements.browLeft, frames.browLeft, options),
    animate(elements.browRight, frames.browRight, options),
    animate(elements.mouthFlat, frames.mouth, options),
    animate(elements.ramboHeadband, frames.headband, options),
    animate(elements.ramboGunLeft, frames.gunLeft, options),
    animate(elements.ramboGunRight, frames.gunRight, options),
    animate(elements.ramboFlashLeft, frames.flashLeft, options),
    animate(elements.ramboFlashRight, frames.flashRight, options),
    animate(elements.glow, frames.glow, options),
    ...scene.ramboCasings.map((casing, index) => animate(casing, createRamboCasingFrames(index), options)),
    ...scene.ramboStreaks.map((streak, index) => animate(streak, createRamboStreakFrames(index), options)),
  ];

  await Promise.allSettled(animations.map(({ finished }) => finished));
}
